import {
    atom,
} from 'recoil';

export const SelectedPage = atom({
    key: 'SelectedPageKnowledgeBase',
    default: "about"
})